module.exports = __webpack_public_path__ + "img/tryListen.524fbb88.png";